<div (click)="$event.stopPropagation()">
  @for (option of SORT_OPTIONS; track option) {
    <div class="sort__option" (click)="selectSort(option)" [ngClass]="{'selected': option.isSelected}">
      <mat-icon class="sort__check" [style]="option.isSelected ? '' : 'opacity: 0'">check</mat-icon>
      <span class="sort__title">{{ option.sort | translate }}</span>
    </div>
  }
</div>
